import React, { useState } from "react";
import {
  CardWrapper,
  DeleteIcon,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import { Carousel, Tooltip } from "antd";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { LuCalendarDays } from "react-icons/lu";
import { GrView } from "react-icons/gr";
import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";

export default ({ data, handleUpdate, handleDelete }) => {
  const [threeDotsClicked, setThreeDotsClicked] = useState(false);

  const nextArrow = (
    <FaChevronRight className="custom-arrow custom-arrow-right" />
  );
  const prevArrow = (
    <FaChevronLeft className="custom-arrow custom-arrow-left" />
  );

  return (
    <CardWrapper>
      {threeDotsClicked && (
        <ThreeDotsContainer
          onMouseOver={() => setThreeDotsClicked(true)}
          onMouseOut={() => setThreeDotsClicked(false)}
        >
          <UpdateIcon onClick={() => handleUpdate(data)}>
            <FiEdit /> Tahrirlash
          </UpdateIcon>
          <DeleteIcon
            onClick={() => {
              handleDelete(data?.id);
            }}
          >
            <FiTrash2 /> O‘chirish
          </DeleteIcon>
        </ThreeDotsContainer>
      )}

      <div className="card-header">
        <button
          className="dotsWrap"
          onClick={() =>
            threeDotsClicked
              ? setThreeDotsClicked(false)
              : setThreeDotsClicked(true)
          }
        >
          <FiMoreVertical viewBox="0 2 5 24" className="three-dots" />
        </button>
      </div>
      <div className="image-wrapper">
        {data?.img?.length > 1 ? (
          <Carousel
            arrows
            dots={false}
            infinite={true}
            prevArrow={prevArrow}
            nextArrow={nextArrow}
          >
            {data.img.map((item, i) => (
              <div key={i}>
                <img src={item} crossOrigin="anonymous" alt="" />
              </div>
            ))}
          </Carousel>
        ) : (
          <img src={data?.img} crossOrigin="anonymous" alt="" />
        )}
      </div>
      <div className="card-title">
        <h1 className="author">{data?.author}</h1>
        <Tooltip
          title={data?.desc}
          placement="bottom"
          overlayStyle={{
            backgroundColor: "#fff",
          }}
        >
          <div className="slice-text">{data?.title}</div>
        </Tooltip>
      </div>

      <div className="card-date-and-views">
        <div className="innner-date-and-view">
          <LuCalendarDays size={14} /> {data.date}
        </div>
        <div className="innner-date-and-view">
          <GrView size={14} /> {data.views}
        </div>
        {/* <div className="innner-date-and-view">
          {"O'qish : "}
          {data?.study_time}
        </div> */}
      </div>
    </CardWrapper>
  );
};
